import * as React from 'react';

import { getRangeValue } from '../../../../../JsonQuery';
import { LandArea } from '../../../components/filters/LandArea';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const LandAreaContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();
  const landArea = getRangeValue('site')(jsonQuery);

  const handleLandAreaMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setLandAreaMin', arguments: [gte] });
      onApply();
    },
    [onApply, onChange],
  );

  const handleLandAreaMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setLandAreaMax', arguments: [lte] });
      onApply();
    },
    [onApply, onChange],
  );

  return (
    <LandArea
      landArea={landArea}
      onLandAreaMinChange={handleLandAreaMinChange}
      onLandAreaMaxChange={handleLandAreaMaxChange}
    />
  );
};
